import React, { useState, useEffect } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import useWindowDimensions from 'customHook/useWindowDimensions'
import { useQuery } from "@apollo/client";
import { GET_VOUCHERS_SUMMARY_BY_DATE } from "graphql/service";
import { OverviewContainer, NavigatorContainer, Navigator } from "./styles";
import moment from "moment-timezone";
import { TIME_ZONE } from "constants/constant";
import { debouncedErrorMessage } from "utils/messageUtil";

const HotelOverview = ({
  selectedDate,
  setSelectedDate
}) => {

  const { width } =useWindowDimensions()
  const containerWidth = width/1440 * 1.35 * 300
  const { data: hotelOverviewData, error } = useQuery(GET_VOUCHERS_SUMMARY_BY_DATE, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: { 
      input: {
        from: moment().tz(TIME_ZONE).format("YYYY-MM-DD"),
        numberOfDays: 30
      },
    },
  });

  const hotelOverviewArray = hotelOverviewData?.dailyVoucherSummary || [];

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  const [pageNumber, setPageNumber] = useState(1)
  const pageSize = 3
  const pageCount = Math.ceil(hotelOverviewData?.dailyVoucherSummary?.length/pageSize)

  const paginate = (array, page_size, page_number) => {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array?.slice((page_number - 1) * page_size, page_number * page_size);
  }

  const previousPage = () => {
    if(pageNumber > 1) {
      setPageNumber((pageNumber) => pageNumber-1)
    }
  }

  const nextPage = () => {
    if(pageNumber < pageCount) {
      setPageNumber((pageNumber) => pageNumber+1)
    }
  }

  const hotelOverviewRows = paginate(hotelOverviewArray, pageSize, pageNumber).map(
    (hotelOverview, index) => (
      <tr
        key={index}
        className={selectedDate === moment(hotelOverview.date).tz(TIME_ZONE).format("YYYY-MM-DD") ? "active" : ""}
        onClick={() => setSelectedDate(moment(hotelOverview.date).tz(TIME_ZONE).format("YYYY-MM-DD"))}
      >
        <td className="date">{moment(hotelOverview.date).tz(TIME_ZONE).format("MMM Do")}</td>
        <td className="rooms">{hotelOverview.roomsCount}</td>
        <td className="breakfasts">{hotelOverview.total}</td>
      </tr>
    )
  );

  return (
    <Card
      className="hotelOverview"
      additionalstyle={`
        width: 100%;
        max-width: ${containerWidth}px;
        min-height: 260px;
        height: 100%;
        margin: 7px;
        padding: 0 1px;
      `}
    >
      <CardHeader
        additionalstyle={`
        padding: 16px;
        .type {
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 1px;
        }
      `}
      >
        <div className="cardTitle">Hotel Overview</div>
        {hotelOverviewArray.length > pageSize ? (
          <NavigatorContainer>
            <Navigator
              disabled={pageNumber <= 1}
              onClick={previousPage}
            >
              {"<"} Back
            </Navigator>
            <Navigator
              disabled={pageNumber >= hotelOverviewArray.length / pageSize}
              onClick={nextPage}
            >
              Next {">"}
            </Navigator>
          </NavigatorContainer>
        ) : null}
      </CardHeader>
      <OverviewContainer>
        <thead>
          <tr>
            <th className="date">DATE</th>
            <th className="rooms">ROOMS</th>
            <th className="breakfasts">BREAKFASTS</th>
          </tr>
        </thead>
        <tbody>{hotelOverviewRows}</tbody>
      </OverviewContainer>
    </Card>
  );
};

export default HotelOverview;
